import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// import { langId, langState } from "@recoil/langState";
// import { authState, demo, userInfoState } from "@recoil/userState";
import * as Const from "@utils/Const";
import { Navigate } from "react-router-dom";
// import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
const PrivateRoute = ({ component: RouteComponent }) => {
    //   const location = useLocation();
    //   const isAuth = useRecoilValue(authState);
    //   const params = new URLSearchParams(location.search);
    //   const setRecoilLangIds = useSetRecoilState(langId);
    //   const setRecoilLangs = useSetRecoilState(langState);
    //   const [userInfo, setRecoilUserInfo] = useRecoilState(userInfoState);
    //   const setDemos = useSetRecoilState(demo);
    //   useEffect(() => {
    //     if (isAuth) {
    //       authRoute(setRecoilLangIds, setRecoilLangs, userInfo, setRecoilUserInfo);
    //     } else {
    //       initRoute(setRecoilLangIds, setRecoilLangs, params);
    //     }
    //   }, []);
    //   const sesDemo = localStorage.getItem("demo");
    //   useEffect(() => {
    //     setDemos(!!sesDemo);
    //   }, [sesDemo]);
    let token = localStorage.getItem(Const.TOKEN);
    return _jsx(_Fragment, { children: token ? _jsx(RouteComponent, {}) : _jsx(Navigate, { to: Const.URL_LOGIN }) });
};
export default PrivateRoute;
